import { render, staticRenderFns } from "./WantToBuyProduct.vue?vue&type=template&id=8c89f6c8&scoped=true"
import script from "./WantToBuyProduct.vue?vue&type=script&lang=js"
export * from "./WantToBuyProduct.vue?vue&type=script&lang=js"
import style0 from "./WantToBuyProduct.vue?vue&type=style&index=0&id=8c89f6c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c89f6c8",
  null
  
)

export default component.exports